// @ts-check
import { ClauseNode } from './clauseRenderNode';

/**
 *
 * @param {string | null} value
 * @returns {null | Date}
 */
const normalizeDateTime = value => (value == null ? null : new Date(value));
/**
 * @param {string} value
 * @returns {Date}
 */
const normalizeRequiredDateTime = value => new Date(value);

export class Clause {
  constructor(clause) {
    this.id = clause.id;
    this.supplementaryAgreementId = clause.supplementary_agreement_id;
    this.code = clause.code;
    this.isRequired = !!clause.is_required;
    this.initialValues = (Array.isArray(clause.initial_values) && clause.initial_values.length > 0
      ? clause.initial_values
      : []
    );

    this.layoutPdf = clause.layout_pdf;
    this.type = clause.type;
    this.createdAt = normalizeRequiredDateTime(clause.created_at);
    this.updatedAt = normalizeRequiredDateTime(clause.updated_at);
    this.permittedValues = clause.permitted_values;

    this.layoutWeb = (clause.layout_web || []).map(node => ClauseNode.create(node, this));
  }
}

export class Agreement {
  constructor(agreement) {
    this.id = agreement.id;
    this.code = agreement.code;
    this.title = agreement.title;
    this.description = agreement.description;
    this.startDate = normalizeDateTime(agreement.start_date);
    this.endDate = normalizeDateTime(agreement.end_date);
    this.validityDurationDays = agreement.validity_duration_days;
    this.createdAt = normalizeRequiredDateTime(agreement.created_at);
    this.updatedAt = normalizeRequiredDateTime(agreement.updated_at);

    /**
     * @type {Clause[]}
     */
    this.clauses = (agreement.clauses || []).map(clause => new Clause(clause));
  }
}



// WEBPACK FOOTER //
// ./src/classes/agreement.js